module.exports = __webpack_public_path__ + "static/media/skull-crossbones.79410ff7.svg";